import React from 'react';
import PropTypes from 'prop-types';
import { Drawer } from './styles';
import Base from './base';

const SideBar = ({
  opened,
  placement,
  width,
  theme,
  onCollapse,
  ...props
}) => (
  <Drawer
    visible={opened}
    placement={placement}
    closable={false}
    width={width}
    theme={theme}
    onClose={onCollapse}
  >
    <Base width={width} theme={theme} {...props} mode="inline" />
  </Drawer>
);

SideBar.displayName = 'SideBar.Drawer';

SideBar.propTypes = {
  ...Drawer.propTypes,
  ...Base.propTypes,
  opened: PropTypes.bool,
  placement: PropTypes.oneOf(['left', 'right']),
  width: PropTypes.number,
  onCollapse: PropTypes.func,
};

SideBar.defaultProps = {
  ...Drawer.defaultProps,
  ...Base.defaultProps,
  opened: true,
  placement: 'left',
  width: 200,
  onCollapse: () => null,
};

export default SideBar;
